import React from "react";
import {Nav} from "react-bootstrap";

/**
 * Schritt-Anzeige oben im Kampagnen-Assistenten. Bereits erreichbare Schritte
 * sind anklickbar (bei einer neuen, noch nicht gespeicherten Kampagne ist
 * das nur Schritt 1 - erst nach dem ersten Speichern gibt es eine
 * Kampagnen-ID, an die Empfänger/Zeitplan/etc. hängen).
 */
export default function WizardStepper({steps, activeStep, onSelect, canJumpTo}) {
    return (
        <Nav variant="pills" className="wizard-stepper flex-nowrap overflow-auto mb-3 gap-2">
            {steps.map((step) => {
                const reachable = canJumpTo(step.number);
                const isActive = activeStep === step.number;
                return (
                    <Nav.Item key={step.number} className="text-nowrap">
                        <Nav.Link
                            active={isActive}
                            disabled={!reachable}
                            onClick={() => reachable && onSelect(step.number)}
                            style={{cursor: reachable ? "pointer" : "not-allowed"}}
                        >
                            <span className="badge rounded-pill bg-light text-dark me-2">{step.number}</span>
                            {step.label}
                        </Nav.Link>
                    </Nav.Item>
                );
            })}
        </Nav>
    );
}
